import $ from 'jquery';

$('[data-username]').on('keydown', ev => {
    if ([32].includes(ev.which)) {
        ev.preventDefault();
    }
}).on('input', ev => {
    const $elem = $(ev.currentTarget);
    const currentValue = $elem.val();
    let newValue = currentValue.toLocaleLowerCase();
    newValue = newValue.replace(/\s+/g, '-');
    newValue = newValue.replace(/^-+/, '');
    newValue = newValue.replace(/-+$/, '');
    if (newValue !== currentValue) {
        $elem.val(newValue);
    }
});
